import React, { useEffect, useState, useRef } from 'react';
import { Button, Card, message, Dropdown, Modal, Tooltip, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined, PlayCircleOutlined, VideoCameraAddOutlined, LeftOutlined, RightOutlined, CloseOutlined, EllipsisOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { getTwinList } from '../../api/clone';
import { AxiosResponse, AxiosError } from 'axios';
import type { ApiResponse } from '../../types';
import { TwinList, Twin } from '../../types/twin';
import type { MenuProps } from 'antd';
import VideoPlayer from '../components/VideoPlayer';
import { deleteVideo } from '../../api/video';
import { useTranslation } from 'react-i18next';

const { confirm } = Modal;

const Clone = () => {

  const [digitalTwinList, setDigitalTwinList] = useState<Twin[]>([])
  const [canScrollLeft, setCanScrollLeft] = useState<boolean>(false);
  const [canScrollRight, setCanScrollRight] = useState<boolean>(false);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [loadings, setLoadings] = useState<boolean[]>([false, false]);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [lastTemplateId, setLastTemplateId] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);



  const navigate = useNavigate();
  const pageSize: number = 5
  const { t } = useTranslation();


  useEffect(() => {
    fetchTwinList()
  }, [])

  const enterLoading = (index: number, status: boolean = true) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = status;
      return newLoadings;
    });
  }

  const fetchTwinList = () => {
    if (loadings[1] || !hasMore) return;
    enterLoading(1)

    // console.log(currentPage)
    const lastId = lastTemplateId
    const params = {
      pageSize,
      ...(lastId ? { lastId } : {})
    };

    try {
      getTwinList(params).then((res: AxiosResponse<ApiResponse<TwinList>>) => {
        if (res.data.status === 200) {
          const newTwins: Twin[] = res.data.data.items

          //setTimeout(() => {
          setDigitalTwinList(prev => [...prev, ...newTwins]);

          //}, 100000)

          setHasMore(res.data.data.hasMore);
          if (newTwins.length > 0) {
            setLastTemplateId(newTwins[newTwins.length - 1].id)
          }

        }
        enterLoading(1, false)
      }).catch((error: AxiosError) => {
        enterLoading(1, false)
      })
    } finally {

    }
  }



  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [digitalTwinList]);

  const checkScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    setCanScrollLeft(container.scrollLeft > 0);

    setCanScrollRight(container.scrollLeft < container.scrollWidth - container.clientWidth);
  };

  const scroll = (direction: string) => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = 216 * 3; // card width + gap
    const newScrollPosition = direction === 'right'
      ? container.scrollLeft + scrollAmount
      : container.scrollLeft - scrollAmount;

    container.scrollTo({
      left: newScrollPosition,
      behavior: 'smooth'
    });

    setTimeout(checkScroll, 300); // Check after animation
    if (direction === 'right') {
      const isNearRight = container.scrollWidth - (container.scrollLeft + container.clientWidth) < scrollAmount;
      if (isNearRight && !loadings[1] && hasMore) {
        fetchTwinList();
      }
    }
  };

  const handleScroll = () => {
    checkScroll();
  };


  const handleSelectedVideo = (url: string | undefined) => {
    // console.log(url)
    if (!url) {
      message.warning("未生成视频")

    } else {
      setSelectedVideo(url)
    }
  };

  const handleDropdownMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === "1") {
      // setDeleteTwinModal(true)
    }
  }

  const getMenuItems = (twinId: number) => [
    {
      key: '1',
      label: t('delete_video'),
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => handleDeleteTwin(twinId),
     
    }
  ];

  const handleDeleteTwin = (id: number) => {

    confirm({
      content: t('popconfirm.description'),
      onOk: async () => {

        deleteVideo({ id }).then((res: AxiosResponse) => {
          // console.log("twinID", res)
          if (res.data.status === 200) {
            setDigitalTwinList(prevList =>
              prevList.filter(twin => twin.id !== id)
            );
            message.success("删除成功")


            const container = containerRef.current;
            if (container && hasMore) {
              const visibleWidth = container.clientWidth;
              const totalWidth = container.scrollWidth;
              const remainingWidth = totalWidth - container.scrollLeft - visibleWidth;

              if (remainingWidth < 216 * 3) { // 如果剩余内容少于两个卡片宽度
                fetchTwinList();
              }
            }


          } else {
            message.error("删除失败")
          }
        }).catch((error) => {
          console.error('Delete failed:', error);
          message.error("删除失败，请稍后重试");
        })
      }
      ,
      onCancel() {

      }
    })
  };





  return (
    <div className={styles.container}>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <div className={styles.title}>{t('clone.template.title1')}</div>
          {/* <Button type="link" onClick={() => navigate('/console/twin')}>管理数字人</Button>*/}
        </div>


        <div className={styles.carouselWrapper}>
          <div
            ref={containerRef}
            className={styles.scrollContainer}
            onScroll={handleScroll}
          >

            <div className={styles.cardList}>
              <Card className={`${styles.humanCard} ${styles.cardAdd}`} hoverable onClick={() => navigate('/console/clone/templateCreate')}>
                <PlusOutlined className={styles.addIcon} />
                <p>{t('clone.create_template')}</p>
              </Card>
              {loadings[1] &&
                <Spin spinning={loadings[1]}>
                  <Card className={styles.humanCard}>
                  </Card>
                </Spin>
              }


              {digitalTwinList.map((twin: Twin, index: number) => (
                <div key={index} className={styles.templateCard}>

                  {
                    twin.processStatus === 2 ?
                      <div>
                        <Dropdown menu={{ items: getMenuItems(twin.id), onClick: handleDropdownMenuClick }} placement="bottomRight" className={styles.customDropdown}>
                          <button className={styles.menuButton}>
                            <EllipsisOutlined />
                          </button>
                        </Dropdown>
                        <VideoPlayer src={twin.videoUrl} width={200} maxHeight={200} />


                        <button
                          className={styles.createButton}
                          onClick={() => navigate(
                            '/console/clone/videoCreate',
                            {
                              state: {
                                id: twin.id,
                                videoUrl: twin.videoUrl,
                                sourceUrl: twin.sourceUrl,
                                type: twin.type,
                                from: 'template'
                              }
                            }
                          )}
                        >

                          <Tooltip title={t('clone.use_this_template')}>
                            <VideoCameraAddOutlined />
                          </Tooltip>
                        </button>
                      </div> :
                      twin.processStatus === 1 ?
                        <div className={styles.loadCard}>
                          {t('clone.template.processing')}

                        </div> :
                        <div className={styles.loadCard}>
                          <Dropdown menu={{ items: getMenuItems(twin.id), onClick: handleDropdownMenuClick }} placement="bottomRight" className={styles.customDropdown}>
                            <button className={styles.menuButton}>
                              <EllipsisOutlined />
                            </button>
                          </Dropdown>{t('clone.template.waiting_in_line')}
                        </div>

                  }

                </div>

              ))}

            </div>
          </div>

          <button
            className={`${styles.navButton} ${styles.prev}`}
            onClick={() => scroll('left')}
            disabled={!canScrollLeft}
          >
            <LeftOutlined />
          </button>

          <button
            className={`${styles.navButton} ${styles.next}`}
            onClick={() => scroll('right')}
            disabled={!canScrollRight && !hasMore}
          >
            <RightOutlined />
          </button>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <div className={styles.title}>{t('clone.template.title2')}</div>
        </div>
        <div>
          
          {t('clone.coming_soon')}
        </div>
      </div>




    </div>
  );
};

export default Clone;